export var getPassengerTypes = function (state) { return state.passengerTypes; };
